import React, { FC, useCallback } from "react";
import { AppStatus, StatusAmountList } from "../Types";
import { useHistory, useRouteMatch } from "react-router-dom";
import style from "./style.scss";

export interface StatusSelectionItemProps {
    readonly status: AppStatus;
    readonly activeStatus?: AppStatus;
    readonly amount?: number;
    readonly color: string;
    readonly organizationId?: string;
    onSelectStatus(status: AppStatus): void;
}

export interface StatusSelectionProps {
    readonly activeStatus?: AppStatus;
    readonly statusAmountList: StatusAmountList[];
    readonly organizationId?: string;
    onSelectStatus(status: AppStatus): void;
}

// These are the status that we will show
const statuses: AppStatus[] = ["Live", "Ready for Install", "In Review", "Submitted for Review", "Requires Attention", "Incomplete", "Archived", "Other"];

export const StatusSelectionItem: FC<StatusSelectionItemProps> = (props) => {
    const { status, activeStatus, amount, color, onSelectStatus } = props;

    const history = useHistory();
    const { url } = useRouteMatch();

    const selectStatus = useCallback(() => {
        if (status !== activeStatus) {
            onSelectStatus(status);
        }
        const statusURL = `${url}?status=${status}`;
        history.push(statusURL);
    }, [status, activeStatus, url, history, onSelectStatus]);

    return (
        <button
            onClick={selectStatus}
            disabled={amount === 0 || status.startsWith("Other")}
            className={`${style.statusSelectionItem} ${status === activeStatus ? style.statusSelectionItemActive : ""}`}
        >
            <div className={style.statusSelectionItemName}>
                <span>{status}</span>
                <span className={style.statusSelectionItemIndicator} style={{ backgroundColor: color }} />
            </div>
            <span>{amount}</span>
        </button>
    );
};

export const StatusSelection: FC<StatusSelectionProps> = (props) => {
    const { activeStatus, statusAmountList, onSelectStatus, organizationId } = props;

    return (
        <div className={style.statusSelectionContainer}>
            <div className={style.statusSelectionHeading}>
                <span>Status</span>
                <span>Amount</span>
            </div>
            <div className={style.statusSelectionInner}>
                {statuses.map((status) => {
                    const item = statusAmountList.filter((obj) => obj.name === status)[0];
                    if (item) {
                        return (
                            <StatusSelectionItem
                                key={status}
                                status={status}
                                amount={item.value}
                                activeStatus={activeStatus}
                                color={item.color}
                                onSelectStatus={onSelectStatus}
                                organizationId={organizationId}
                            />
                        );
                    } else {
                        return <></>;
                    }
                })}
            </div>
        </div>
    );
};
